import {
  Box,
  BoxSx,
  Spinner,
  SpinnerProps,
  Text,
  ThemeSizes
} from "@modernatx/ui-kit-react";
import React from "react";

interface LoadingSpinnerProps {
  message?: string;
  sx?: BoxSx;
  size: SpinnerProps["size"];
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message,
  sx,
  size
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh" as ThemeSizes,
        flexDirection: "column",
        ...sx
      }}
    >
      <Spinner size={size} />
      <Text variant="h6" sx={{ mt: "spacing-3" }}>
        {message}
      </Text>
    </Box>
  );
};
